import { useEffect, useRef } from "react";

// Nested confirmation dialogs retain ownership of keyboard focus.
export function useDialogFocus(rootRef, active, onClose) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    if (!active || !rootRef.current) return undefined;
    const root = rootRef.current;
    const previous = document.activeElement;
    const initial = root.querySelector('[role="dialog"], [role="alertdialog"]') || root;
    initial.setAttribute("tabindex", "-1");
    initial.focus();
    const onKey = (event) => {
      const dialogs = [...document.querySelectorAll('[aria-modal="true"]')];
      const top = dialogs[dialogs.length - 1];
      if (top && top !== initial && !top.contains(initial)) return;
      const items = [...root.querySelectorAll('button, input, textarea, select, a[href], [tabindex]')]
        .filter((el) => !el.matches(":disabled") && el.tabIndex >= 0 && el.type !== "hidden" && !el.closest('[hidden], [aria-hidden="true"]'));
      if (event.key === "Escape") {
        event.preventDefault(); event.stopPropagation(); closeRef.current?.();
      } else if (event.key === "Tab") {
        const first = items[0]; const last = items[items.length - 1];
        if (!first) { event.preventDefault(); initial.focus(); }
        else if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      if (previous?.isConnected) previous.focus();
    };
  }, [rootRef, active]);
}
